import { useContext } from 'react';
import Icon from 'components/icon/Icon';
import messages from 'messages';
import { StoreContext } from 'index';
import usePerson from 'hooks/queries/usePerson';
import useFetchAndFilterPersonsPool from 'hooks/queries/useFetchAndFilterPersonsPool';
import { MUTATION_REMOVE_EXTERNAL_PERSON_MAPPING } from 'services/aws/integration-query';
import ConfirmMutationButton from 'containers/partials/buttons/ConfirmMutationButton';

const RemoveIntegrationButton = ({
  entityId,
  person,
  integration,
  externalPersonMappingId,
  children,
  ...props
}) => {
  const { uiState } = useContext(StoreContext);
  const { fetchPerson } = usePerson({ personId: person.id });
  const { fetchPool } = useFetchAndFilterPersonsPool({
    entityId
  });

  return (
    <ConfirmMutationButton
      {...props}
      mutation={MUTATION_REMOVE_EXTERNAL_PERSON_MAPPING}
      variables={{ id: externalPersonMappingId }}
      confirmTitle={messages.modalConfirmRemoveIntegrationTitle}
      confirmMessage={messages.modalConfirmRemoveIntegrationMessage}
      messageValues={{
        integration,
        b: chunks => (
          <b style={{ display: 'inline-block', margin: '0 4px' }}>{chunks}</b>
        )
      }}
      update={async (cache, { data: { archiveExternalPersonMapping } }) => {
        if (archiveExternalPersonMapping) {
          await fetchPerson(person.id);
          await fetchPool();
          uiState.decreasePendingRequest();
        }
      }}
    >
      <Icon id="delete" strokeColor="color-neutral-dark" />
      {children}
    </ConfirmMutationButton>
  );
};

export default RemoveIntegrationButton;
